var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCropCalenderDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    style: {
      fill: "currentColor"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crop_calendar",
    transform: "translate(49.871 -26.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23593",
    "data-name": "Path 23593",
    d: "M0,0H20V20H0Z",
    transform: "translate(-49.871 26.15)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9999",
    "data-name": "Group 9999",
    transform: "translate(-7458.434 10750.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28439",
    "data-name": "Path 28439",
    d: "M29.993,6.143V5.186H17.5V4.452H29.993V6.143Z",
    transform: "translate(7394.033 -10723.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28436",
    "data-name": "Path 28436",
    d: "M188.644,156.465l-.277.012a2.293,2.293,0,0,0-1.69.858v-.077l.11-.119a2.3,2.3,0,0,0,0-3.113l-.187-.2a.282.282,0,0,0-.415,0l-.188.2a2.314,2.314,0,0,0,0,3.111l.118.128v.07a2.29,2.29,0,0,0-1.688-.858l-.279-.012a.282.282,0,0,0-.293.293l.012.276a2.3,2.3,0,0,0,2.2,2.2l.05,0v.845a.282.282,0,1,0,.564,0v-.845l.048,0a2.3,2.3,0,0,0,2.2-2.2l.012-.276a.282.282,0,0,0-.293-.293Zm-4.215.576a1.743,1.743,0,0,1,1.631,1.63A1.726,1.726,0,0,1,184.429,157.041Zm1.963-2.612a1.727,1.727,0,0,1,0,2.306,1.743,1.743,0,0,1,0-2.306Zm.338,4.242a1.744,1.744,0,0,1,1.631-1.63,1.727,1.727,0,0,1-1.631,1.63Z",
    transform: "translate(7237.188 -10868.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    d: "M15,21.331h-.665A.333.333,0,0,1,14,21v-.665A.333.333,0,0,1,14.333,20H15a.333.333,0,0,1,.333.333V21A.333.333,0,0,1,15,21.331Z",
    transform: "translate(7403.048 -10737.009)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar-2",
    "data-name": "calendar",
    d: "M15,21.331h-.665A.333.333,0,0,1,14,21v-.665A.333.333,0,0,1,14.333,20H15a.333.333,0,0,1,.333.333V21A.333.333,0,0,1,15,21.331Z",
    transform: "translate(7406.708 -10737.009)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar-3",
    "data-name": "calendar",
    d: "M15,21.331h-.665A.333.333,0,0,1,14,21v-.665A.333.333,0,0,1,14.333,20H15a.333.333,0,0,1,.333.333V21A.333.333,0,0,1,15,21.331Z",
    transform: "translate(7403.048 -10733.926)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar-4",
    "data-name": "calendar",
    d: "M15,21.331h-.665A.333.333,0,0,1,14,21v-.665A.333.333,0,0,1,14.333,20H15a.333.333,0,0,1,.333.333V21A.333.333,0,0,1,15,21.331Z",
    transform: "translate(7406.708 -10733.926)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar-5",
    "data-name": "calendar",
    d: "M15,21.331h-.665A.333.333,0,0,1,14,21v-.665A.333.333,0,0,1,14.333,20H15a.333.333,0,0,1,.333.333V21A.333.333,0,0,1,15,21.331Z",
    transform: "translate(7399.056 -10733.926)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar-6",
    "data-name": "calendar",
    d: "M15,21.331h-.665A.333.333,0,0,1,14,21v-.665A.333.333,0,0,1,14.333,20H15a.333.333,0,0,1,.333.333V21A.333.333,0,0,1,15,21.331Z",
    transform: "translate(7403.048 -10730.466)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar-7",
    "data-name": "calendar",
    d: "M15,21.331h-.665A.333.333,0,0,1,14,21v-.665A.333.333,0,0,1,14.333,20H15a.333.333,0,0,1,.333.333V21A.333.333,0,0,1,15,21.331Z",
    transform: "translate(7399.056 -10730.466)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28440",
    "data-name": "Path 28440",
    d: "M27.217,16H18.152C17.517,16,17,15.292,17,14.421V2.579C17,1.708,17.517,1,18.152,1H29.088c.634,0,1.15.708,1.15,1.579V7.908h-.575V2.579c0-.435-.258-.789-.575-.789H18.152c-.318,0-.576.354-.576.789V4.947h.008v.79h-.008v8.684c0,.436.258.79.576.79h9.065V16Z",
    transform: "translate(7394 -10723)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropCalenderDark);
export default __webpack_public_path__ + "static/media/crop_calender_dark.ae79e179e098a3d14301b5d25591cdf2.svg";
export { ForwardRef as ReactComponent };